import React, {useState} from 'react';
import { classNames } from '../../Services/helpers';
import Icon from '../Icons/Icon';
import Loading from '../Loading';

const ButtonBar = ({buttons, className, size = "md"}) => {
    return <div className={classNames(
        'flex flex-row justify-around align-middle gap-2 surface-2 p-1 rounded-lg shadow-inner',
        className
    )}>
        {buttons.map((button) => <Button key={button.label ?? button.icon} size={size} {...button} />)}
    </div>
}

const Button = ({label, icon, loading, onClick, onClickLoading, selected, size}) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        try {
            onClickLoading && setIsLoading(true);

            onClick && await onClick();

            onClickLoading && setIsLoading(false);
        } catch (error) {
            onClickLoading && setIsLoading(false);
            throw error;
        }
    }

    const iconTheme = selected ? 'solid' : 'light';
    const _loading = loading || isLoading;
    const iconMargin = label ? 'mr-2' : '';

    return <button className={classNames(
        size === 'md' && 'px-4 py-2',
        size === 'sm' && 'px-2 py-1',
        'grow rounded-lg transition-bg duration-300',
        selected && 'surface-1 font-bold shadow-xs',
        'dark:hover:bg-black/75 text-muted hover:bg-white/75 hover:cursor-pointer',
        selected && 'text-brand fill-brand',
    )} onClick={handleClick}>
        {_loading && <Loading className={iconMargin} />}
        {(!_loading && icon) && <Icon icon={icon} theme={iconTheme} className={iconMargin} />}
        {label}
    </button>
}

export default ButtonBar;
